import "./clients-list.scss";
import { usePage } from "@inertiajs/react";

export default function ClientsList({ clients = [] }) {
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const clientsData = clients?.data || clients || [];

    return (
        <div className="clientsList">
            {clientsData.map((category) => (
                <div className="clientsList__item" key={category.id}>
                    <h3
                        dangerouslySetInnerHTML={{
                            __html: category.title?.[locale] || category.title,
                        }}
                    />
                    <div className="clientsList__item__info">
                        {category.clients?.map((client) =>
                            client.url ? (
                                <a
                                    key={client.id}
                                    href={client.url}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {client.title}
                                </a>
                            ) : (
                                <span key={client.id}>{client.title}</span>
                            ),
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
